var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormwater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3723 17.75H54.3324C53.7124 17.75 53.2124 18.25 53.2124 18.87V21.57H46.2224C36.5324 21.57 28.6523 29.45 28.6523 39.14V46.73C28.6523 50.05 25.9523 52.76 22.6223 52.76C19.2923 52.76 16.5924 50.06 16.5924 46.73V13.15H18.7823C19.4023 13.15 19.9023 12.65 19.9023 12.03V1.62C19.9023 1 19.4023 0.5 18.7823 0.5H1.75232C1.13232 0.5 0.632324 1 0.632324 1.62V12.03C0.632324 12.65 1.13232 13.15 1.75232 13.15H3.15234V46.78C3.15234 57.52 11.8923 66.25 22.6223 66.25C33.3523 66.25 42.0924 57.51 42.0924 46.78V39.92C42.0924 37.21 44.2923 35.01 47.0023 35.01H53.2024V36.74C53.2024 37.36 53.7024 37.86 54.3224 37.86H63.3624C63.9824 37.86 64.4824 37.36 64.4824 36.74V18.86C64.4824 18.24 63.9824 17.74 63.3624 17.74H63.3723V17.75ZM2.88232 10.92V2.76H17.6724V10.92H2.88232ZM53.2124 32.78H47.0123C43.0623 32.78 39.8524 35.99 39.8524 39.94V46.8C39.8524 56.3 32.1223 64.03 22.6223 64.03C13.1223 64.03 5.39233 56.3 5.39233 46.8V13.17H14.3424V46.75C14.3424 51.31 18.0524 55.02 22.6124 55.02C27.1724 55.02 30.8823 51.31 30.8823 46.75V39.16C30.8823 30.71 37.7524 23.84 46.2024 23.84H53.1924V32.79H53.2124V32.78ZM62.2523 35.63H55.4524V20H62.2523V35.63Z",
    fill: "#C17A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormwater);
export default __webpack_public_path__ + "static/media/stormwater.f4d087e99fd1e6006b4502670368f68d.svg";
export { ForwardRef as ReactComponent };